import { inject } from "@angular/core";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import { ModalService } from "@core-services/modal.service";
import { PriceAlert } from "@models";
import { AccountService } from "@modules/account/services/account.service";
import { PricewatchAddModalComponent } from "./components/pricewatch-add-modal.component";

export const pricewatchAddModalResolverFn: ResolveFn<boolean | RedirectCommand> = (route) => {
	const router = inject(Router);
	const modalService = inject(ModalService);
	const accountService = inject(AccountService);
	const assetId =
		route.paramMap.get("assetId") ?? route.queryParamMap.get("asset_id") ?? route.queryParamMap.get("assetId");

	if (!assetId) {
		return new RedirectCommand(router.parseUrl("/home"));
	}

	const fiat = accountService.getDefaultFiat();
	if (!fiat) {
		return new RedirectCommand(router.parseUrl("/home"));
	}

	const priceAlert = new PriceAlert();
	priceAlert.setCurrencyId(assetId);
	priceAlert.setFiatId(fiat.getId());

	modalService.create(PricewatchAddModalComponent, { data: priceAlert }, { showCloseButton: true }).present();

	return true;
};
